import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createLead,
  getLeadDetails,
  getLeadList,
  updateAssignLead,
  updateLeadStatus,
} from '../services/leadService';
import {
  getStatusDrop,
  getLeadTypeDropValues,
} from '../services/dropDownService';
import { LeadInitialStateType } from '../utils/Types';
import { API_STATUS, BlankPagination } from '../utils/Constant';
import { isAPISuccess } from '../utils/Util';

const initialState: LeadInitialStateType = {
  leadListData: {
    result: [],
    pagination: BlankPagination,
  },
  leadTypeOptions: [],
  statusDropOptions: [],
  apiProgressStatus: '',
};

export const fetchLeadList = createAsyncThunk(
  'lead/fetchLeadList',
  async (data: any) => {
    const res = await getLeadList(data);
    return res.data;
  }
);

export const creteNewLead = createAsyncThunk(
  'lead/createLead',
  async (data: any) => {
    const res = await createLead(data);
    return res.data;
  }
);

export const assignLeadToOther = createAsyncThunk(
  'lead/assignLead',
  async (data: any) => {
    const res = await updateAssignLead(data);
    return res.data;
  }
);

export const fetchLeadDetails = createAsyncThunk(
  'lead/fetchLeadDetails',
  async (params: any) => {
    const res = await getLeadDetails(params);
    return res.data;
  }
);

export const updateLeadStatusDetails = createAsyncThunk(
  'lead/updateLeadStatusDetails',
  async (data: any) => {
    const res = await updateLeadStatus(data);
    return res.data;
  }
);

export const fetchLeadTypeDrops = createAsyncThunk(
  'lead/fetchLeadTypeDrops',
  async () => {
    const res = await getLeadTypeDropValues();
    return res.data;
  }
);

export const fetchLeadStatusDrops = createAsyncThunk(
  'lead/fetchLeadStatusDrops',
  async (params: any) => {
    const res = await getStatusDrop(params);
    return res.data;
  }
);

export const leadSlice = createSlice({
  name: 'lead',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLeadList.fulfilled, (state, action) => {
        state.apiProgressStatus = API_STATUS.SUCCEEDED;
        state.leadListData = action.payload;
      })
      .addCase(fetchLeadList.pending, (state) => {
        state.apiProgressStatus = API_STATUS.LOADING;
      })
      .addCase(fetchLeadList.rejected, (state) => {
        state.apiProgressStatus = API_STATUS.FAILED;
      })
      .addCase(fetchLeadStatusDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const dropdowns = action.payload.result?.map((item: any) => ({
            value: item.statusId,
            label: item.statusName,
          }));
          state.statusDropOptions = dropdowns;
        }
      })
      .addCase(fetchLeadTypeDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const dropdowns = action.payload.result?.map((item: any) => ({
            value: item.leadTypeId,
            label: item.leadTypeName,
          }));
          state.leadTypeOptions = dropdowns;
        }
      });
  },
});

export const leadSelector = (state: { lead: LeadInitialStateType }) =>
  state.lead;

export const leadApiStatus = (state: { lead: LeadInitialStateType }) =>
  state.lead.apiProgressStatus;

export default leadSlice.reducer;
